import Component from "gia/Component";
import Channels from "../base/channels";
import gsap from "gsap";
import { ScrollTrigger } from "../vendor/gsap-bonus-umd/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);
import { getCoords } from "../utils/utils";

export default class Module extends Component {
  constructor(element) {
    super(element);
    this.ref = {};
  }

  mount() {
    this.DOM = {};
    this.DOM.view = this.element;

    this.animate();
    this.listener();

    Channels.on("smoothscroll::redraw", () => {
      this.st.refresh();
    });
  }

  animate() {
    this.tl = gsap.timeline();

    this.tl.add([
      gsap.fromTo(
        this.ref.nav,
        {
          y: 170,
        },
        {
          y: 0,
          ease: "linear",
          duration: 1,
          delay: 0.1,
        }
      ),
      gsap.fromTo(
        this.ref.logo,
        {
          y: 200,
        },
        {
          y: 0,
          ease: "linear",
          duration: 1,
        }
      ),
    ]);
  }

  listener() {
    this.st = ScrollTrigger.create({
      animation: this.tl,
      trigger: this.ref.dummy[0],
      start: "top bottom",
      end: () => {
        const coord = getCoords(this.ref.dummy[0]);

        return `+=${coord.height}px`;
      },
      markers: false,
      scrub: true,
    });
  }

  unmount() {
    this.st.kill();
  }
}
